import { render } from "./Arts.vue?vue&type=template&id=ee8bf96e"
import script from "./Arts.vue?vue&type=script&lang=js"
export * from "./Arts.vue?vue&type=script&lang=js"

import "./Arts.vue?vue&type=style&index=0&id=ee8bf96e&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__